import React from "react";

const Breadcrumbs = ({steps, showLastStepCheckSymbol=false}: {steps: any, showLastStepCheckSymbol?: boolean}) => {
  return (
    <div className="free-trial-breadcrumbs__wrapper">
      <div className="free-trial-breadcrumbs">
        {steps.map((step:any, index:any) => (
          <div className="free-trial-breadcrumb-item">
            {
              showLastStepCheckSymbol ? 
              (<div className="check-icon">✔</div>) :
              (<div className="check-icon" style={{visibility: index === (steps.length-1) ? 'hidden' : 'visible'}}>✔</div>)
            }
            <span className="step-text">{step}</span>
            <div className="arrow" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumbs;
